export default __webpack_public_path__ + "static/media/SR_Gawain.3238ed16.png";